export const AuthEndpoint = {
  checkRegister: '/auth/check-register',
  sendOtp: '/auth/send-otp',
  sendMobileOtp: '/auth/real-send-otp',
  verifyOtp: '/auth/verify-otp',
  verifyMobileOtp: '/auth/real-verify-otp',
  loginDisplay: '/auth/check-login-status',
  registerMobile: '/auth/real-register',
}
